<template>
  <div>
    <el-dialog
      title="付款"
      custom-class="MyDialog"
      :visible.sync="isShowProcure3PayDialog"
      @close="closeProcure3PayDialog"
      width="30%"
    >
      <div class="cash-payment-wrap">
        <!--支付宝支付-->
        <template v-if="status !== 1 && Choice === 'mixue_alipay_code'">
          <div class="cash-money">
            支付<span>{{ elsePayMoney }}</span
            >元
          </div>
          <div
            v-if="Choice === 'mixue_alipay_code' && this.payUrl"
            class="qr-code"
          >
            <div class="qr-code" ref="qrCodeUrl"></div>
          </div>
          <div v-else class="empty-qrcode">
            二维码生成中...
          </div>
          <p class="pay-cash-type">使用支付宝扫一扫</p>
        </template>
        <template v-if="status !== 1 && Choice === 'mixue_wechat_code'">
          <div class="cash-money">
            支付<span>{{ elsePayMoney }}</span
            >元
          </div>
          <div
            v-if="Choice === 'mixue_wechat_code' && this.payUrl"
            class="qr-code"
          >
            <div class="qr-code" ref="qrCodeUrl"></div>
          </div>
          <div v-else class="empty-qrcode">
            二维码生成中...
          </div>
          <p class="pay-cash-type">使用微信扫一扫</p>
        </template>
        <template v-else>
          <p v-if="vvvvv === 1">二维码地址不正确</p>
        </template>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { OnFinish_Type } from "@/util/keys";
import {
  getStudyPayStatus,
  agentStudyPayUrl,
  agentStudyCreditPayUrl
} from "@/api/AccountInterface";
import QRCode from "qrcodejs2-fix";

export default {
  name: "Procure3Pay",
  data() {
    return {
      payMethodText: {
        alipay_code: "支付宝",
        wechat_code: "微信支付"
      },
      message: "",
      weixin: false,
      zhifubao: true,
      vvvvv: 0,
      sign: 2,
      Data: [],
      flowId: "", //支付流水号
      userName: "", //操作人
      payTime: "", //充值时间
      amount: "", //充值金额
      payMethodText: "", //支付方式解释
      rechargeId: "", //订单编号
      payUrl: "", //二维码地址
      account: "", //账户余额
      judgement: true, //一页面  是否显示判断值
      WeChat: false, //微信
      Alipay: false, //支付宝
      visible: false, //选择支付方式
      previewVisible: false,
      previewImage: "", //选择支付方式  1 微信   2 支付宝
      bodylist: [],
      payType: "mixue_alipay_code", //选择了支付方式  1 微信   2 支付宝 3 银行转账
      accountss: "", //充值了多少金额
      data: "",
      status: "", //扫码成功接口返回值Initialization
      Initia: "",
      Initia1: "",
      dialogTitle: "",
      isSuccess: false,
      money: 0,
      isShowProcure3PayDialog: false
    };
  },
  props: {
    elsePayMoney: {
      type: String | Number,
      default: 0
    },
    Choice: {
      type: String,
      default: ""
    },
    orderNo: {
      type: String | Number,
      default: ""
    },
    procure3PayDialog: {
      type: Boolean,
      default: false
    },
    orderType: {
      type: String,
      default: ""
    }
  },
  watch: {
    procure3PayDialog: {
      handler(newVal, oldVal) {
        this.isShowProcure3PayDialog = newVal;
      },
      immediate: true
    }
  },
  mounted() {
    this.ImmediateRecharge();
    sessionStorage.setItem(OnFinish_Type, JSON.stringify(1));
  },
  methods: {
    ImmediateRecharge() {
      const params = {
        amount: this.elsePayMoney, //sc111
        payMethod: this.Choice, //已经选择了支付方式   1 微信   2 支付宝
        purchaseOrderNo: this.orderNo
      };
      if (this.orderType == "online" || this.orderType == "doubleOrder" || this.orderType == "callCenter") {
        // 线上订单、双重订单
        agentStudyPayUrl(params).then(async ret => {
          if (ret.code === 0) {
            this.randCodeForpay = ret.data.randCodeForpay; //支付码
            this.campusId = ret.data.campusId; //代理商ID
            this.payUrl = ret.data.object.qr_code || ret.data.object.code_url; //二维码支付链接
            this.rechargeId = ret.data.rechargeId || ""; //订单编号
            this.payMethodText = this.payMethodText[this.Choice]; //支付方式
            this.message = ret.message; //
            this.creatQrCode();
            this.Transfer();
          }
          if (ret.message) {
            this.$message.error(ret.message || "付款失败");
          }
        });
      } else if (this.orderType == "creditorders") {
        //  赊货订单
        agentStudyCreditPayUrl(params).then(async ret => {
          if (ret.code === 0) {
            this.randCodeForpay = ret.data.randCodeForpay; //支付码
            this.campusId = ret.data.campusId; //代理商ID
            this.payUrl = ret.data.object.qr_code || ret.data.object.code_url; //二维码支付链接
            this.rechargeId = ret.data.rechargeId || ""; //订单编号
            this.payMethodText = this.payMethodText[this.Choice]; //支付方式
            this.message = ret.message; //
            this.creatQrCode();
            this.Transfer();
          }
          if (ret.message) {
            this.$message.error(ret.message || "付款失败");
          }
        });
      }
    },
    creatQrCode() {
      this.$nextTick(() => {
        new QRCode(this.$refs.qrCodeUrl, {
          text: this.payUrl, // 二维码的内容
          width: 150,
          height: 150,
          colorDark: "#000",
          colorLight: "#fff",
          correctLevel: QRCode.CorrectLevel.H
        });
      });
    },
    RechargeServiceAgreement() {
      window.open(
        "https://qrcode-sto-oss.xstudyedu.com/static/充值服务协议.pdf"
      );
    },
    Transfer() {
      this.Initia = setInterval(() => {
        getStudyPayStatus({ rechargeId: this.rechargeId }).then(ret => {
          if (ret.code === 0) {
            if (ret.data) {
              clearInterval(this.Initia);
              if (ret.code === 0 && ret.data) {
                this.paySuccess(this.elsePayMoney, true);
              } else {
                this.$message.error(ret.message || "付款失败");
                this.paySuccess(this.elsePayMoney, false);
              }
            }
          }
        });
      }, 3000);
    },
    paySuccess(money, isSuccess) {
      this.Initia && clearInterval(this.Initia);
      this.$emit("paySuccess", money, isSuccess);
    },
    closeProcure3PayDialog() {
      this.Initia && clearInterval(this.Initia);
      this.isShowProcure3PayDialog = false;
    }
  },
  beforeDestroy() {
    this.Initia && clearInterval(this.Initia);
  }
};
</script>

<style lang="scss" scoped>
.cash-payment-wrap {
  .cash-money {
    font-size: 28px;
    text-align: center;
    font-weight: bolder;
    color: #ff0000;
    margin-bottom: 10px;
  }
  .qr-code {
    padding: 10px;
    display: flex;
    justify-content: center;
  }
  .pay-cash-type {
    margin-top: 10px;
    font-size: 18px;
    text-align: center;
  }
  .empty-qrcode {
    width: 150px;
    height: 150px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    border: 1px solid #ededed;
  }
}
</style>
